// extracted by mini-css-extract-plugin
module.exports = {"link":"linkpage-module--link--24bit"};